'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$createEmojiNode = $createEmojiNode;
exports.$isEmojiNode = $isEmojiNode;
exports.EmojiNode = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lexical = require("lexical");
var _EmojiNode;
class EmojiNode extends _lexical.TextNode {
  constructor() {
    let className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let key = arguments.length > 2 ? arguments[2] : undefined;
    console.log('EmojiNode constructor', className, text, key);
    super(text, key);
    (0, _defineProperty2.default)(this, "createDOM", config => {
      const dom = document.createElement('span');
      const inner = super.createDOM(config);
      dom.className = this.__className;
      inner.className = 'emoji-inner';
      dom.appendChild(inner);
      return dom;
    });
    this.__className = className;
  }
  updateDOM(prevNode, dom, config) {
    const inner = dom.firstChild;
    if (inner === null) return true;
    super.updateDOM(prevNode, inner, config);
    return false;
  }
}
exports.EmojiNode = EmojiNode;
_EmojiNode = EmojiNode;
(0, _defineProperty2.default)(EmojiNode, "getType", () => 'emoji');
(0, _defineProperty2.default)(EmojiNode, "clone", node => {
  return new _EmojiNode(node.__className, node.__text, node.__key);
});
function $isEmojiNode(node) {
  return node instanceof EmojiNode;
}
function $createEmojiNode(className, emojiText) {
  return new EmojiNode(className, emojiText).setMode('token');
}
